import React from "react";
import { ChipsPopup } from "./ChipsPopup";
import { NumericFormat } from "react-number-format";
import DateFormat from "../../../util/DateFormat";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";
export function LeaderboardPopup(props) {
  ChipsPopup(
    props,
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: calc(200),
          marginTop: calc(16),
          padding: `0 ${calc(16)}`,
          color: "#3D3D3D",
          textAlign: "center",
          fontFamily: "Spoqa Han Sans Neo",
          fontSize: calc(18),
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "150%",
          flex: "1 0 0",
        }}
      >
        랭킹
      </div>

      <div
        style={{
          position: "absolute",
          top: calc(12),
          right: calc(8),
          padding: calc(8),
          cursor: "pointer",
        }}
        onClick={() => {
          if (!props.close || !props.close()) {
            props.dismiss();
          }
        }}
      >
        <img
          style={{
            width: calc(20),
            height: calc(20),
          }}
          src="/games/fruits/assets/ic-title-back.png"
        />
      </div>

      <div
        className="scrollbar-hidden"
        onTouchMove={(event) => {
          event.stopPropagation();
        }}
        style={{
          minHeight: calc(291),
          maxHeight: calc(291),
          overflow: "scroll",
        }}
      >
        <img
          style={{
            width: calc(240),
            marginTop: calc(8),
          }}
          src={props.leaderBoard.prize_image_url}
        />

        {props.leaderBoard.winners && props.leaderBoard.winners.length >= 3 ? (
          <LeaderBoardUsers users={props.leaderBoard.winners} />
        ) : (
          <div
            style={{
              minHeight: calc(138),
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              marginTop: calc(8),
            }}
          >
            <span
              style={{
                color: "#212121",
                textAlign: "center",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(14),
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "142.857%",
                letterSpacing: "-0.2px",
              }}
            >
              랭킹 점수 집계 중
            </span>
            <span
              style={{
                color: "#888",
                textAlign: "center",
                fontFamily: "Spoqa Han Sans Neo",
                fontSize: calc(12),
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "150%",
                letterSpacing: "-0.2px",
              }}
            >
              랭킹 점수를 집계하고 있어요.
            </span>
          </div>
        )}

        {props.leaderBoard.notice ? (
          <LeaderBoardNotice notice={props.leaderBoard.notice} />
        ) : null}
      </div>

      {props.leaderBoard.uid ? (
        <LeaderBoardMyInfo user={props.leaderBoard} />
      ) : null}
    </div>,
  );
}

function LeaderBoardNoticeItem({ notice }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
      }}
    >
      <img
        src={`/games/fruits/assets/ic-notice-dot.png`}
        style={{
          width: calc(18),
          height: calc(18),
        }}
      />
      <span
        style={{
          color: "#888",
          textAlign: "start",
          fontFamily: "Spoqa Han Sans Neo",
          fontSize: calc(12),
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "150%",
          wordBreak: "keep-all",
        }}
      >
        {notice}
      </span>
    </div>
  );
}

function LeaderBoardNotice({ notice }) {
  const rows = [];
  notice.split("\n").forEach((notice) => {
    rows.push(<LeaderBoardNoticeItem notice={notice} />);
  });

  return (
    <div
      style={{
        width:
          "calc(100% - var(--nbt-width) * (20 + 20 + 12 + 12) / var(--nbt-canvas-width))",
        margin: `${calc(8)} ${calc(20)}`,
        padding: calc(12),
        borderRadius: calc(7),
        background: "#F5F5F5",
        display: "flex",
        flexDirection: "column",
        gap: calc(8),
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          color: "#212121",
          textAlign: "center",
          fontFamily: "Spoqa Han Sans Neo",
          fontSize: calc(12),
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "150%",
        }}
      >
        유의사항
      </div>
      {rows}
    </div>
  );
}

function LeaderBoardMyInfo({ user }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
      }}
    >
      <div
        style={{
          width:
            "calc(100% - var(--nbt-width) * (20 + 20 + 8 + 8) / var(--nbt-canvas-width))",
          margin: `${calc(8)} ${calc(20)}`,
          padding: `${calc(4)} ${calc(8)}`,
          borderRadius: calc(7),
          border: `${calc(1)} solid #FF8A00`,
          background: "#FFEDCB",
          display: "flex",
          flexDirection: "row",
          gap: calc(8),
        }}
      >
        <div
          style={{
            minWidth: calc(38),
            color: "#FF8A00",
            textAlign: "center",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(14),
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "150%",
            transform: "translateY(4%)",
          }}
        >
          {user.rank > 0 ? user.rank : "-"}
        </div>

        {user.profile_image_url ? (
          <img
            src={user.profile_image_url}
            style={{
              width: calc(32),
              height: calc(32),
              borderRadius: calc(16),
            }}
          />
        ) : (
          <img
            src={`/games/fruits/assets/game_img_80_profile_${uidToIndex(
              user.uid,
            )}.png`}
            style={{
              width: calc(32),
              height: calc(32),
              borderRadius: calc(16),
            }}
          />
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            transform: "translateY(6%)",
          }}
        >
          <div
            style={{
              color: "#212121",
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(12),
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "150%",
            }}
          >
            {user.nickname}
          </div>
          <span
            style={{
              color: "#FF8A00",
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(12),
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "150%",
            }}
          >
            <NumericFormat
              displayType="text"
              thousandSeparator=","
              value={user.score}
              style={{
                fontSize: calc(14),
              }}
            />
            점
          </span>
        </div>
      </div>
    </div>
  );
}

function uidToIndex(uid) {
  var uidAscii = uid
    .split("")
    .map((char) => char.charCodeAt(0))
    .reduce((current, previous) => previous + current);
  return (Math.abs(uidAscii) % 10) + 1;
}

export function LeaderBoardUsers({ users }) {
  const rows = [];
  users.forEach((user) => {
    rows.push(<LeaderBoardUser user={user} />);
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: calc(224),
        gap: calc(12),
        margin: `${calc(12)} 0 0 0`,
      }}
    >
      {rows}
    </div>
  );
}

function LeaderBoardUser({ user }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: calc(8),
      }}
    >
      {user.rank <= 3 ? (
        <img
          src={`/games/fruits/assets/img_rank${user.rank}_24.png`}
          style={{
            width: calc(24),
            height: calc(24),
          }}
        />
      ) : (
        <span
          style={{
            minWidth: calc(24),
            color: "#9E9E9E",
            textAlign: "center",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(14),
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "150%",
          }}
        >
          {user.rank}
        </span>
      )}

      {user.profile_image_url ? (
        <div>
          <img
            src={user.profile_image_url}
            style={{
              borderRadius: calc(16),
              width: calc(32),
              height: calc(32),
              objectFit: "cover",
            }}
          />
        </div>
      ) : (
        <div>
          <img
            src={`/games/fruits/assets/game_img_80_profile_${uidToIndex(
              user.uid,
            )}.png`}
            style={{
              borderRadius: calc(16),
              width: calc(32),
              height: calc(32),
              objectFit: "cover",
            }}
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "flex-start",
        }}
      >
        <span
          style={{
            color: "#212121",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(12),
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "150%",
          }}
        >
          {user.nickname}
        </span>
        <span
          style={{
            color: user.rank <= 3 ? "#FF8A00" : "#212121",
            fontFamily: "Spoqa Han Sans Neo",
            fontSize: calc(12),
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "150%",
          }}
        >
          <NumericFormat
            displayType="text"
            thousandSeparator=","
            value={user.score}
            style={{
              fontSize: calc(14),
            }}
          />
          점
        </span>
      </div>
    </div>
  );
}
